import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "flex h-screen overflow-hidden" }
const _hoisted_2 = { class: "titleFont text-2xl md:text-3xl" }
const _hoisted_3 = {
  key: 0,
  class: "mx-auto mt-5"
}
const _hoisted_4 = {
  key: 1,
  class: "mx-auto"
}
const _hoisted_5 = { class: "md:flex" }
const _hoisted_6 = {
  key: 0,
  class: "fixed bottom-0 left-0 w-full"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex space-x-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-[50px] m-3",
      src: _imports_0
    }),
    /*#__PURE__*/_createElementVNode("h3", { class: "logoFont text-3xl" }, "Wizzl")
  ])
], -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Separator = _resolveComponent("Separator")!
  const _component_LoginIcon = _resolveComponent("LoginIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_HrWithText = _resolveComponent("HrWithText")!
  const _component_GoogleIcon = _resolveComponent("GoogleIcon")!
  const _component_AuthCenterBox = _resolveComponent("AuthCenterBox")!
  const _component_AuthSettingsButtonComponent = _resolveComponent("AuthSettingsButtonComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AuthCenterBox, null, {
        default: _withCtx(() => [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
          _createVNode(_component_Separator),
          (!_ctx.noForm)
            ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default")
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Button, {
                    class: "m-1 text-lg",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/auth/login')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Sign in')) + " ", 1),
                      _createVNode(_component_LoginIcon)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Button, {
                    class: "m-1 text-lg",
                    grayTheme: true,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/auth/register')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Register')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_HrWithText, { title: "or" }),
                _createVNode(_component_Button, {
                  hasIcon: true,
                  grayTheme: true,
                  class: "m-1",
                  onClick: _ctx.googleLogin
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_GoogleIcon, {
                      class: _normalizeClass({'animate-spin': _ctx.googleLoading})
                    }, null, 8, ["class"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Sign in with')) + " ", 1),
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('Google')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
        ]),
        _: 3
      })
    ]),
    _createVNode(_component_AuthSettingsButtonComponent),
    (!_ctx.$store.getters['appearence/keyboardOpen'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true)
  ], 64))
}